import apiUrls from "../urls";

export default function (api) {
  return {
    getDistributorTransactions(perPage, currentPage) {
      return api.get(
        `${apiUrls.DIST_TRANSACTIONS}?perPage=${perPage}&currentPage=${currentPage}`,
      );
    },
    getSellerTransactions(perPage, currentPage) {
      return api.get(
        `${apiUrls.SELLER_TRANSACTIONS}?perPage=${perPage}&currentPage=${currentPage}`,
      );
    },
  };
}
